export default __webpack_public_path__ + "static/media/GST-CERTIFICATE-INSHA-BANGALES-PVT-LTD-2.9109b7f4.jpg";